<!-- eslint-disable @angular-eslint/template/conditional-complexity -->
<!-- FIXME this is a messy logic, we need to move some to Pandora and some to the component ts -->

<div class="product-price">
  @if (showLabel && hasDiscount && discountPercentage >= 10) {
    <div class="product-price__label-offer">
      <span>{{ discountPercentage | number: '1.0-1' }}% <br /><span i18n="@@OFF">OFF</span></span>
    </div>
  }
  @if (hasDiscount && showPercentage && discountPercentage >= 10) {
    <div class="product-price__percentage">
      <i class="fa fa-tags"></i>
      <span i18n="@@DISCOUNT_PRICE_TEXT">Sale</span><span> {{ discountPercentage | number: '1.0-1' }}%</span>
    </div>
  }
  @if (hasDiscount && showDiscounted && (!hideCrossedPrice || (hideCrossedPrice && isOfferFeed))) {
    <div class="product-price__discounts">
      <i class="fal fa-tags" aria-hidden="true"></i>
      @if (showPercentage) {
        <span i18n="@@DISCOUNT_PRICE_TEXT">Sale</span> {{ discountPercentage | number: '1.0-1' }}%:
      }
      <span i18n="@@DISCOUNT_AMOUNT_TEXT">You save</span> {{ diffPrice | currency: currency : 'symbol' : '1.2-2' }}
    </div>
  }
  <div class="product-price__prices">
    <div class="product-price__prices-wrapper">
     @if (showCrossedPrice ) {
        @if( +crossedPriceManager.finalCrossedPrice > 0 ){
          @if (showFromPriceText) {
            <span class="product-price__from" i18n="@@product.from">From</span>
          }
          <span class="product-price__crossed">{{
            crossedPriceManager.finalCrossedPrice | currency: currency : 'symbol' : '1.2-2'}}
          </span>
        }
      }
      <span class="product-price__total">{{ priceInfo?.price | currency: currency : 'symbol' : '1.2-2' }}</span>
    </div>
    @if (pricePerUnit > 0) {
      <div class="product-price__unit_price_wrapper">
        <div class="product-price__unit_price" i18n="@@product.price_per_unit">
          ( {{ pricePerUnit | currency: currency : 'symbol' : '1.2-2' }} / unit )
        </div>
      </div>
    }
  </div>
</div>
